export function parseOptions(text: string): string[] {
  const lines = text.split('\n').map(l => l.trim()).filter(Boolean)

  // Primary: numbered list ("1. label" or "1) label") — what the phase 20 prompt mandates
  const numbered = lines
    .filter(l => /^[0-9]+[.)]\s/.test(l))
    .map(l => l.replace(/^[0-9]+[.)]\s*/, '').trim())
    .filter(l => l.length > 2 && l.length < 120)
  if (numbered.length >= 3) return numbered.slice(0, 10)

  // Fallback: bullet points ("- label", "• label", "* label")
  const bullets = lines
    .filter(l => /^[-•*]\s/.test(l))
    .map(l => l.replace(/^[-•*]\s*/, '').trim())
    .filter(l => l.length > 2 && l.length < 120)
  if (bullets.length >= 3) return bullets.slice(0, 10)

  // Last resort: short non-prose lines (chips are never full sentences)
  return lines
    .filter(l => l.length > 4 && l.length < 80 && !/[.?!]$/.test(l))
    .slice(0, 10)
}
